<template>
  <div class="dui-file-list panel background-yellow-fade">
    <div
      v-for="fileEntry in files"
      :key="fileEntry.file.name"
      class="file-entry grid-flex grid-middle grid-no-response"
    >
      <div class="grid-item ellipsis">
        {{ fileEntry.file.name }} {{ getFileSize(fileEntry) }}
      </div>
      <div class="grid-item-shrink">
        <a @click="removeFile(fileEntry)">
          <span class="hidden-until-md">remove</span>
          <DuiIconCross class="visible-until-sm icon-sm icon-circle background-yellow-base icon-white" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import prettyBytes from 'pretty-bytes';

export default {
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getFileSize(fileEntry) {
      if (!fileEntry ||
        !fileEntry.file ||
        !fileEntry.file.size) {
        return '';
      }

      return `(${ prettyBytes(fileEntry.file.size) })`;
    },

    removeFile(fileEntry) {
      this.$emit('remove-file', fileEntry);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-file-list {
  color: getColor($yellow, medium);
  font-weight: $base-weight-bold;

  .file-entry {
    margin-top: $_1em;

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
